import Label from "../../atoms/label/Label";
import styles from "./dealDetailsPromotions.module.scss";
import PropTypes from "prop-types";
import labels from "../../../config/labels";
import LinkRoute from "../../atoms/linkRoute/LinkRoute";
import config from "../../../config";
import { isExternalUrl } from "../../../utils/helperServices"

const DealDetailsPromotions = ({
	variant,
	tagText,
	description,
	isPromotionTagLink,
	promotionTag,
	descriptionTime,
	promotionLink,
	flag,
	labelColor,
}) => {

	if (!(tagText || description || promotionLink)) return "";

	const generateVariantStyle = () => {
		return variant ? styles["promotion--" + variant] : "";
	};

	// For Filter with on the appropriate promotion on product list page
	const createPromotionFilter = (value, label) => value + ":" + label;
	const env = config.env;
	const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;

	return (
			<div className={`${styles.promotion} ${generateVariantStyle()}`} >
				{tagText && (
					<Label className={`${styles["promotion__tag"]}`} text={tagText} labelColor={labelColor} />
				)}

				{ isPromotionTagLink || promotionLink
					? promotionLink !== null && (	
							<div>
								<LinkRoute
									href={promotionLink
										? (isExternalUrl(promotionLink) ? `${promotionLink}` : `${urlPrefix}/${promotionLink}`)
										: `${urlPrefix}/deals`
									}
									as={promotionLink
										? null
										: `${urlPrefix}/deals?promotions=${createPromotionFilter(
											promotionTag,
											variant
										)}`
									}
									text={labels.lbl_promotion_tag_link}
									className={`${styles["promotion__description__link"]}`}
								/>
								<a> &nbsp;{labels.lbl_promotion_tag_text}</a>
							</div>
						)
					: ( !flag
						?
							<span className={styles["promotion__description"]}>
								{description}<span className={styles["description_font"]}>{descriptionTime}</span>
							</span>
						: ""
					)}
			</div>
	);
};

DealDetailsPromotions.defaultProps = {
	className: "",
	variant: "",
	promotionTag: "",
};

DealDetailsPromotions.propTypes = {
	className: PropTypes.string,
	description: PropTypes.string,
	descriptionTime:  PropTypes.string,
	flag: PropTypes.bool,
	isPromotionTagLink: PropTypes.bool,
	labelColor: PropTypes.string,
	promotionTag: PropTypes.string,
	promotionLink: PropTypes.string,
	tagText: PropTypes.string,
	variant: PropTypes.string,
};

export default DealDetailsPromotions;
